import { observable, action, reaction } from 'mobx';
import agent from '../api/agent';

class CommonStore {

  @observable appName = 'Your Masterpieces';
  @observable token = false;
  @observable loading = false;
  @observable loadingProgress = false;
  @observable completeProgress = false
  @observable loadingPercent = 0;
  @observable searchedKeyword = "";

  // window.localStorage.getItem('userData') ;

  @observable appLoaded = false;

  @observable tags = [];
  @observable isLoadingTags = false;

  constructor() {
    reaction(
      () => this.token,
      token => {
        if (token) {
          window.localStorage.setItem('userData', token);
        } else {
          window.localStorage.removeItem('userData');
        }
      }
    );
  }

  @action loadTags() {
    this.isLoadingTags = true;
    return agent.Tags.getAll()
      .then(action(({ tags }) => { this.tags = tags.map(t => t.toLowerCase()); }))
      .finally(action(() => { this.isLoadingTags = false; }))
  }

  @action setToken(token, display_name, image, profile_id, preferred_currency,login_email,name) {
    // console.log("[look at  userdata]", token, display_name, image)
    this.token = token;
    if (display_name) {
      window.localStorage.setItem('display_name', (display_name.length > 30) ? "" : display_name);
    } else {
      window.localStorage.removeItem('display_name');
    }
    if (image) {
      window.localStorage.setItem('image', (!!image) ? image : require('../assets/default_picture.png'));
    } else {
      window.localStorage.removeItem('image');
    }
    if (profile_id) {
      window.localStorage.setItem('profile_id', profile_id);
    } else {
      window.localStorage.removeItem('image');
    }
    if (preferred_currency) {
      window.localStorage.setItem('preferred_currency', preferred_currency);
    } else {
      window.localStorage.removeItem('preferred_currency');
    }
    if (!preferred_currency) {
      
      window.localStorage.removeItem('goog_email');
      window.localStorage.removeItem('goog_id');
      window.localStorage.removeItem('fb_id');
    }
    window.localStorage.setItem('login_email', login_email);
    window.localStorage.setItem('full_name', name);
    
  }
  @action setTokenAfterRegister(token, profile_id) {
    // debugger;

    // console.log("[look at  userdata]", token, profile_id)
    this.token = token;
    if (!!profile_id) {
      window.localStorage.setItem('profile_id', profile_id);
    } else {
      window.localStorage.removeItem('profile_id');
    }
    window.localStorage.removeItem('preferred_dimension');
    window.localStorage.removeItem('fb_email');

  }

  @action setAppLoaded() {
    this.appLoaded = true;
  }

  @action setLoader() {
    this.loading = true;
  }
  @action setProgressLoader(forArtwork) {

    // console.log("{setProgressLoader}", this.loadingProgress)
    this.loadingProgress = true;
    this.loadingProgressForArtwork = forArtwork;
    // console.log("{setProgressLoader}", this.loadingProgress)
    this.interval = setInterval(() => this.tick(), 1000);
  }

  @action tick() {
    // console.log("{setProgressLoader}", this.loadingPercent)
    while (this.loadingPercent < 100) {
      this.loadingPercent = this.loadingPercent + 2
      // console.log("{setProgressLoader changed}", this.loadingPercent)

    }
  }


  @action removeLoader() {
    this.loading = false;
    this.loadingProgress = false;
    this.completeProgress = false;
    this.loadingPercent = 0;
    clearInterval(this.interval)
  }
  @action makeProgressComplete() {
    this.completeProgress = true;
  }
  @action setSearchedKeyword(input) {
    if (input) {
      this.searchedKeyword = input
    }
    else this.searchedKeyword = ""
  }
}

export default new CommonStore();



// WEBPACK FOOTER //
// ./src/stores/commonStore.js